import { render, staticRenderFns } from "./accordionComponent.vue?vue&type=template&id=3af275c9&scoped=true&"
import script from "./accordionComponent.vue?vue&type=script&lang=js&"
export * from "./accordionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af275c9",
  null
  
)

export default component.exports